import React from "react";
import cx from "classnames";
import isEqual from "is-equal";
import InputField from "src/legacy/components/InputField";
import Download from "src/legacy/components/Download";
import UserGroupsAutoCompleteContainer from "src/legacy/components/UserGroupsAutoComplete/UserGroupsAutoCompleteContainer";
import styles from "./inviteUserFormComponent.module.scss";
import { Collapse, Dropdown } from "react-bootstrap";
import { localizedStrings } from 'src/localization/index.jsx';
import Button from "src/components/button";
import SwitchButton from "src/components/switchButton";
import Toast from "src/components/toast";
import userRoleService from "src/utils/userRoles.service";
import _ from "lodash";
import { toast } from "react-toastify";

class InviteUserFormComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      admin: false,
      createStream: false,
      canViewReports: false,
      groups: [],
      errors: null,
      expand: false,
      activeUserRole: null,
      isStarterLicence: false,
      starterRole: false
    };

    this._handleChange = this._handleChange.bind(this);
    this.onUserGroupsChange = this.onUserGroupsChange.bind(this);

    this._handleSendClick = this._handleSendClick.bind(this);
    this._handleCancelClick = this._handleCancelClick.bind(this);
    this._handleUserRole = this._handleUserRole.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this.renderForm = this.renderForm.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonLoading = this.localizedCommons.loading;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizedSettings = localizedStrings.pages.settings;
    this.localizedUserManagement = this.localizedSettings.account.user_management;
    this.localizedInviteUser = this.localizedUserManagement.invite_user;
  }

  componentDidMount() {
    this.props.fetchUserRolesForAccount();
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.error, this.props.error)) {
      if (nextProps.error) {
        this.setState({
          errors: {
            email: nextProps.error[0].message,
          },
        });
      }
    }
  }

  _handleChange(field, e) {
    if (field == "email") {
      this.setState({
        [field]: e.target.value,
      });
    } else {
      let createStream = this.state.createStream;
      let canViewReports = this.state.canViewReports;
      if (
        field == "admin" &&
        !this.state.admin &&
        (!createStream || !canViewReports)
      ) {
        createStream = true;
        canViewReports = true;
      } else if (field == "createStream") {
        createStream = !this.state.createStream;
      } else if (field === "canViewReports") {
        canViewReports = !this.state.canViewReports;
      }
      this.setState({
        [field]: !this.state[field],
        createStream: createStream,
        canViewReports: canViewReports,
      });
    }
  }

  onUserGroupsChange(groups) {
    this.setState({
      groups: groups,
    });
  }

  onUserRolesChange(roles) {
    this.setState({
      roles: roles,
    });
  }

  _handleUserRole(userRole) {
    this.setState({
      activeUserRole: userRole,
    });
  }

  _handleSendClick() {
    const errors = this.validateForm();
    if (Object.keys(errors).length != 0) {
      this.setState({
        errors: errors,
      });

      return;
    }

    let user = {
      email: this.state.email,
      admin: this.state.admin,
      canCreateStream: this.state.createStream,
      canViewReports: this.state.canViewReports,
      userGroups: this.state.groups,
      userRoles:
        !_.get(this.state, "starterRole") &&
        _.size(this.state.activeUserRole) > 0
          ? [_.get(this.state, "activeUserRole.id")]
          : [],
      starterRole: _.get(this.state, "isStarterLicence"),
    };

    this.props.inviteUser(user)
    .then((response) => {
      if (response.type == "LEGACY_INIVITE_USER_SUCCEDDED") {
        toast(
          <Toast.Sucess
            message={localizedStrings.formatString(this.localizedInviteUser.toast.success, {
              email: this.state.email,
            })}
          />,
          {
            autoClose: 3000,
          }
        );

        this._handleCancelClick();
        this.props.navigate("/settings/user-management/invitation");
      }
    });
  }

  _handleCancelClick() {
    this.setState({
      email: "",
      admin: false,
      createStream: false,
      groups: [],
      errors: [],
      activeUserRole: [],
    });

  }

  validateForm() {
    let errors = {};
    const { email } = this.state;

    if (!email || email.trim == "") {
      errors.email = this.localizedInviteUser.error_message;
    }

    const regex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!regex.test(email)) {
      errors.email = this.localizedInviteUser.error_message;
    }

    if (email.includes("@qq.")) {
      errors.email = this.localizedInviteUser.error_message;
    }

    return errors;
  }

  getErrorForField(field) {
    if (!this.state.errors) {
      return null;
    }

    return this.state.errors[field];
  }
  handleToggle() {
    this.setState((prevState) => ({
      isStarterLicence: !prevState.isStarterLicence,
      starterRole: !prevState.starterRole
    }));
  }

  renderForm() {
    return (
      <>
       
      </>
    )
  }

  render() {
    var roles = _.map(this.props.userRoles, (userRole, index) => {
      return (
        <Dropdown.Item
          className={styles.userRoleItem}
          key={index}
          onClick={this._handleUserRole.bind(this, userRole)}
        >
          {userRole.name}
        </Dropdown.Item>
      );
    }) || [];

    var popoverMenu = (
      <Dropdown.Menu>
        {this.props.account && this.props.account.manageRoles && (
          <Dropdown.Item
            className={cx(styles.createNewRole, styles.userRoleItem)}
          onClick={() => this.props.navigate("/settings/user-roles/new")}
          >
            {" "}
            <i className="fa fa-plus" /> {this.localizedInviteUser.role.create_new_role}{" "}
          </Dropdown.Item>
        )}
        {roles}
      </Dropdown.Menu>
    );

    var headers = [];
    var fileName = "Reports";

    var id = this.props.filter.value;
    if (id.includes("all") || id.includes("users")) {

      fileName = "Users";
      headers = [
        [this.localizedInviteUser.headers.first_name],
        [this.localizedInviteUser.headers.last_name],
        [this.localizedInviteUser.headers.email],
        [this.localizedInviteUser.headers.joined_date],
        [this.localizedInviteUser.headers.role],
        [this.localizedInviteUser.headers.status],
        [this.localizedInviteUser.headers.user_groups]
      ];
    } else if (id.includes("invitations")) {

      fileName = "Invitations";
      headers = [[this.localizedInviteUser.headers.email], [this.localizedInviteUser.headers.status], [this.localizedInviteUser.headers.invited_date]];

    } else if (id.includes("user_groups")) {

      fileName = "UserGroups";
      headers = [[this.localizedInviteUser.headers.name], [this.localizedInviteUser.headers.created_date], [this.localizedInviteUser.headers.total_users]];

    }

    return (
      <div className={styles.content}>

        <div className={styles.headingContainer}>
        <span className={styles.heading}>{this.localizedUserManagement.title}</span>

        <Download
          id={this.props.filter.value}
          fileName={fileName}
          headers={headers}
          fetchData={this.props.downloadReport}
          pagination={this.props.download ? this.props.download.pagination : {}}
          downloaded={this.props.download ? this.props.download.downloaded : false}
          error={this.props.download ? this.props.download.error : null}
          data={this.props.download ? this.props.download.items : []}
          className={styles.download}
        />

        </div>

        {this.props.activeUsers > 0 && (
          <div className={styles.activeUsers}>
            {this.localizedUserManagement.active_users}{" "}
            <span className={styles.count}>({this.props.activeUsers})</span>
          </div>
        )}
        <p
          className={cx(
            styles.subHeading,
            !this.state.expand ? styles.collapsed : ""
          )}
          onClick={() => {
            this.setState({ expand: !this.state.expand });
          }}
        >
          <i
            className={cx(
              styles.indicator,
              { ["paperflite-add"]: !this.state.expand },
              { ["paperflite-minus"]: this.state.expand }
            )}
          />
          {this.localizedUserManagement.actions.invite_user}
        </p>
        <Collapse in={this.state.expand}>
        <div>
          <InputField
            className={styles.inputField}
            title={`${this.localizedInviteUser.email}:`}
            placeholder=""
            value={this.state.email}
            type="text"
            focus={true}
            reference="focusOn"
            onChange={this._handleChange.bind(this, "email")}
            errorMessage={this.getErrorForField("email")}
          />
      

        <div style={{ display: "flex", flexDirection: "row" }}>
          <div 
          className={cx(styles.userSettings, styles.control)}
          >
            <div 
            className={cx(styles.label, styles.settingsName,
              { [styles.settingsNameDisabled]: this.state.isStarterLicence })}
            >
              {this.localizedInviteUser.role.title}:
            </div>
            <div 
            className={styles.select}
            >
              {!_.get(this.state, "isStarterLicence") && (
                <Dropdown id="dropdown-user-role" rootCloseEvent="click">
                  <Dropdown.Toggle>
                    {this.state.activeUserRole
                      ? this.state.activeUserRole.name
                      : this.localizedInviteUser.role.placeholder}
                  </Dropdown.Toggle>
                  {popoverMenu}
                </Dropdown>
              )}
            </div>
          </div>
          <div
            className={cx(
              styles.userSettings,
              styles.control,
              styles.groupName
            )}
          >
            <div 
            className={cx(styles.label, styles.settingsName)}
            >
              {this.localizedInviteUser.group_name.title}:
            </div>
            <div className={styles.selectGroup}>
              <UserGroupsAutoCompleteContainer
                className={styles.autoComplete}
                placeholder={this.localizedInviteUser.group_name.placeholder}
                ref={(element) => {
                  this.userGroupsAutoComplete = element;
                }}
                onChange={this.onUserGroupsChange}
                groups={this.state.groups}
              />
            </div>
          </div>
        </div>
        {userRoleService.canAccessStarterRole(_.get(this.props, "account")) &&  ( 
          <div className={styles.switchButtonContainer}>
            <SwitchButton
              id="switchButton"
              className={styles.switchButton}
              checked={this.state.isStarterLicence}
              handleCheck={this.handleToggle}
            />
            <span className={styles.switchText}>{this.localizedInviteUser.role.starter_role}</span>
          </div>
          )}
        <div className={styles.buttonTray}>
          <Button
            text={this.props.inviting ? `${this.localizedCommonActions.sending}...` : this.localizedInviteUser.actions.send_invite}
            variant="primary"
            disabled={this.props.inviting}
            onClick={this._handleSendClick}
            icon='paperflite-tick'
            className={styles.sendButton}
          ></Button>
          <Button
            text={this.localizedCommonActions.cancel}
            variant="secondary"
            disabled={this.props.inviting}
            onClick={() => {
              this._handleCancelClick();
            }}
          ></Button>
        </div>
        </div>
        </Collapse>
      </div>
    );
  }
}

export default InviteUserFormComponent;
